import { useEffect, useState } from 'react';
import { GET_DRAFT_CURRENCIES } from '../constants/aryGraphqlSchemas';
import { useShowCurrenciesContext } from '../contexts/ShowCurrenciesContextProvider';
import { useAryLazyQuery } from './useAryGraphql';

function useCurrencyDecimalPlaces(branchId, ifGetDraftCurrency = false) {
  const showCurrenciesContext = useShowCurrenciesContext();

  const [currencies, setCurrencies] = useState([]);

  const [getCurrencies] = useAryLazyQuery({
    gqlConfig: GET_DRAFT_CURRENCIES,
    items: `
      code
      title
      decimalPlaces
    `
  });

  useEffect(() => {
    (async () => {
      if (ifGetDraftCurrency) {
        const resp = await getCurrencies(branchId);
        if (resp?.data) {
          setCurrencies(resp.data);
        }
      } else {
        setCurrencies(showCurrenciesContext);
      }
    })();
  }, []);

  function getCurrencyDecimalPlaces({ code, title }) {
    if ((!code && !title) || !currencies?.length) return null;
    const desiredCurrency =
      currencies?.find((currency) =>
        code ? currency.code === code : currency.title === title
      ) || '';
    return desiredCurrency?.decimalPlaces;
  }

  return [getCurrencyDecimalPlaces];
}

export default useCurrencyDecimalPlaces;
